import { render, staticRenderFns } from "./Picks.vue?vue&type=template&id=c77495d2&scoped=true"
import script from "./Picks.vue?vue&type=script&lang=js"
export * from "./Picks.vue?vue&type=script&lang=js"
import style0 from "./Picks.vue?vue&type=style&index=0&id=c77495d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77495d2",
  null
  
)

export default component.exports